// Fetch request
async function saveQL(variables) {
  const query = `query (
    $title:String,
    $description:String,  
    $roomType: Int,
    $categories: [Int],
    $category: Int,
    $suggestedCategory: String,
    $basePrice: Float,
    $hourlyRate: Float,
    $weeklyDiscount: Int,
    $addresses: [Int],
    $rules: [String],
    $blockedDates: [String],
    $id: Int,
    $userId: String,
  ) {
      createListing (
        title:$title,
        description:$description,
        roomTypes:[$roomType],
        categories:$categories,
        category: $category,
        suggestedCategory: $suggestedCategory,
        basePrice: $basePrice,
        weeklyDiscount: $weeklyDiscount,
        hourlyRate: $hourlyRate,
        addresses: $addresses,
        listingRules: $rules,
        blockedDates: $blockedDates,
        bookingType: "request",
        id: $id,
        adminProvidedUser: $userId
      ) {
        status
        id
      }
    }`;

  console.log('submitting', variables);

  try {
    const resp = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables,
      }),
      credentials: 'include',
    });

    const res = await resp.json();
    console.log('SUBMITTED LISTING DATA', res);
    return res;
  } catch (err) {
    console.log('saveQL - Catch - ', err);
  }
  return;
}

export default saveQL;



// WEBPACK FOOTER //
// ./src/components_new/addListing/saveQL.js